import { createI18n } from 'vue-i18n'
import { getStore } from '@/utils/store'
import zh from './package/zh'

const i18n = createI18n({
	locale: getStore({ name: 'language' }) || 'zh',
	fallbackLocale: 'zh',
	legacy: false,
	messages: {
		en: {
			...zh
		},
		// 中文
		zh: {
			...zh
		}
	},
	silentTranslationWarn: true
})

export default i18n
